import * as React from "react";

export type IProgramInfo = any; // TODO: Declare this

export default React.createContext<IProgramInfo>({});
